import React, { ReactNode } from "react";
import styles from "./Card.module.css";
import clsx from "clsx";

interface CardProps {
  children: ReactNode;
  isActive?: boolean;
  className?: string;
  subClassName?: string;
}

const Card: React.FC<CardProps> = ({
  children,
  className,
  subClassName,
  isActive = false,
}) => {
  return (
    <div className={clsx(styles["container"], className)}>
      <div
        className={clsx(
          styles["sub-container"],
          subClassName,
          isActive && styles["active"]
        )}
      >
        <div className={styles["card-container"]}>{children}</div>
      </div>
    </div>
  );
};

export default Card;
